import React, { useEffect } from 'react';
import SEOHead from '../components/SEO/SEOHead';
import Hero from '../components/Home/Hero';
import Feature from '../components/Home/Feature';
// import InviteFriend from '../components/Home/Invite';
// import ProcessList from '../components/Process/List';
import TestimonialList from '../components/Testimonials/List';
import Download from '../components/Downloads/Download';
import ContactUs from '../components/Home/ContactUs';
import Faqs from '../components/Home/FAQ';
// import useAuthContext from '../hooks/useAuthContext';
import { useLocation } from 'react-router-dom';
import Header from '../components/Layout/Header';
import Footer from '../components/Layout/Footer';
import SpecialOffers from '../components/Home/SpecialOffers';
import ReferralSection from '../components/Home/ReferralSection';
import ClientOnly from '../components/Common/ClientOnly';
import FreeRechargeSection from '../components/Home/FreeRechargeSection';
import TropipuntosSection from '../components/Home/TropipuntosSection';

export default function Home() {
  /* Hooks */
  // const { isAuthenticated } = useAuthContext();
  const location = useLocation();

  useEffect(() => {
    const element = document.getElementById(location.hash.substring(1));
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 100,
        behavior: 'smooth'
      });
    }
  }, [location]);

  return (
    <div className="mt-5">
      <SEOHead
        title="Recargas de Móvil a Cuba Rápidas y Seguras"
        description="Recarga saldo móvil a Cuba en minutos desde cualquier país. Servicio rápido, seguro y confiable. Regístrate gratis y recarga hoy."
        path="/"
        schemas={['Organization', 'WebSite', 'Service', 'FAQPage']}
      />
      <ClientOnly>
        <div className="fixed inset-x-0 top-0 z-50 ">
          <Header />
        </div>
      </ClientOnly>

      {/* Hero section */}
      <Hero />

      {/* Feature Section */}
      <Feature />

      {/* Download */}
      <div className="px-2 sm:px-10">
        <Download />
      </div>

      {/* Invite a friend */}
      {/* {isAuthenticated && <div className='my-24'><InviteFriend /></div>} */}

      {/* Process List */}
      {/* <div className={`${isAuthenticated  && isAuthenticated ? 'mt-24' : 'mt-0'}`}>
        <ProcessList />
      </div> */}

      {/* Opinions List */}
      <TestimonialList />

      <ClientOnly>
        <SpecialOffers />
      </ClientOnly>

      {/* FAQs se carga client-only: datos dinámicos del API evitan hydration mismatch */}

      {/* Referral Section */}
      <ReferralSection />

      {/* Free Recharge Section */}
      <FreeRechargeSection />

      {/* Tropipuntos Section */}
      <TropipuntosSection />

      {/* Contact Us */}
      <ContactUs />

      {/* FAQs */}
      <ClientOnly>
        <Faqs />
      </ClientOnly>

      <Footer />
    </div>
  );
}
